(function () {
  document.addEventListener("variantChange", function(e) {
    var variant = e.detail.variant;
    var $price_container = document.getElementById('product-block--price-container');

    if ($price_container) {
      var $price = document.getElementById('product-block--price');
      var $compare_price = document.getElementById('product-block--compare-price');
      var $reference_unit = document.getElementById('product-block--reference-unit');
      var $reference_value = document.getElementById('product-block--reference-value');
      var $unit_price_container = document.getElementById('product-block--unit-price-container');
      var $unit_price = document.getElementById('product-block--unit-price');
      if (!variant) {
        $price_container.style.display = 'none';
        return;
      } else {
        $price_container.style.display = null;
      }
      variant_price = theme.utils.formatMoney(variant.price);
      $price.innerHTML = variant_price;
      if (variant.compare_at_price > variant.price) {
        compare_price = theme.utils.formatMoney(variant.compare_at_price);
        $compare_price.innerHTML = compare_price;
        $compare_price.style.display = 'inline-block';
      } else {
        $compare_price.style.display = 'none';
      }
      if (variant.unit_price_measurement) {
        unit_price = theme.utils.formatMoney(variant.unit_price);
        $unit_price.innerHTML = unit_price;
        $reference_unit.innerHTML = variant.unit_price_measurement.reference_unit;
        if (variant.unit_price_measurement.reference_value === 1) {
          $reference_value.style.display = 'none';
        } else {
          $reference_value.innerHTML = variant.unit_price_measurement.reference_value;
          $reference_value.style.display = 'block';
        }
        return $unit_price_container.style.display = 'flex';
      } else {
        return $unit_price_container.style.display = 'none';
      }
    }
  });
})();